
import { CSSProperties } from "@mui/material";

export const TabsStyle: CSSProperties = {
    minHeight: 40,
    width: '100%',
    borderBottom: '1px solid',
    borderColor: 'divider',
    '& .MuiTabs-indicator': {
        height: 3,
        borderRadius: 2
    }
}

export const TabStyles: CSSProperties = {
    textTransform: 'none',
    minHeight: 40,
    px: 2,
    fontWeight: 500,
    color: 'text.secondary',
    '&.Mui-selected': {
        color: 'primary.main',
        fontWeight: 600
    }
};